import p5 from "p5";

const sketch = (p: p5) => {
    let particles: Particle[] = [];
    const numParticles = 80;

    class Particle {
        x: number;
        y: number;
        vx: number;
        vy: number;
        size: number;
        color: p5.Color;

        constructor() {
            this.x = p.random(p.width);
            this.y = p.random(p.height);
            this.vx = p.random(-0.6, 0.6);
            this.vy = p.random(-0.6, 0.6);
            const maxSize = Math.min(p.width, p.height) / 20;
            this.size = p.random(4, maxSize);
            // Random color between #f39 and #39f
            this.color = p.lerpColor(p.color("#f39"), p.color("#39f"), p.random());
        }

        update() {
            this.x += this.vx;
            this.y += this.vy;

            // Wrap around edges
            if (this.x < 0) this.x = p.width;
            if (this.x > p.width) this.x = 0;
            if (this.y < 0) this.y = p.height;
            if (this.y > p.height) this.y = 0;
        }

        draw() {
            p.push();

            // Calculate distance from center for transparency effect (elliptical)
            const centerX = p.width / 2;
            const centerY = p.height / 2;
            const ellipseRadiusX = p.width * 0.33; // 33% of width
            const ellipseRadiusY = p.height * 0.15; // 15% of height
            const normalizedDistX = (this.x - centerX) / ellipseRadiusX;
            const normalizedDistY = (this.y - centerY) / ellipseRadiusY;
            const ellipticalDist = Math.sqrt(normalizedDistX * normalizedDistX + normalizedDistY * normalizedDistY);
            const centerAlpha = ellipticalDist < 1.0
                ? p.map(ellipticalDist, 0, 1.0, 0.0, 1.0) * p.map(ellipticalDist, 0, 1.0, 0.0, 1.0)
                : 1.0;

            // Draw glow (multiple layers for smooth effect)
            for (let i = 5; i > 0; i--) {
                const glowSize = this.size + i * 4;
                const glowAlpha = 0.1 * (6 - i) * centerAlpha;
                const glowColor = p.color(this.color.toString());
                glowColor.setAlpha(glowAlpha * 255);
                p.fill(glowColor);
                p.noStroke();
                p.circle(this.x, this.y, glowSize);
            }

            // Draw particle
            const particleColor = p.color(this.color.toString());
            particleColor.setAlpha(centerAlpha * 255);
            p.fill(particleColor);
            p.circle(this.x, this.y, this.size);
            p.pop();
        }
    }

    p.setup = () => {
        const canvas = p.createCanvas(p.windowWidth, p.windowHeight);
        canvas.style("position", "fixed");
        canvas.style("top", "0");
        canvas.style("left", "0");
        canvas.style("z-index", "-1");

        // Initialize particles
        for (let i = 0; i < numParticles; i++) {
            particles.push(new Particle());
        }
    };

    p.draw = () => {
        // Dark gradient background
        p.background(0, 4, 53); // Same as CSS background

        // Draw connections between nearby particles
        for (let i = 0; i < particles.length; i++) {
            for (let j = i + 1; j < particles.length; j++) {
                const distance = p.dist(
                    particles[i].x,
                    particles[i].y,
                    particles[j].x,
                    particles[j].y
                );

                if (distance < 125) {
                    // Calculate center transparency for connection lines (elliptical)
                    const centerX = p.width / 2;
                    const centerY = p.height / 2;
                    const lineX = (particles[i].x + particles[j].x) / 2;
                    const lineY = (particles[i].y + particles[j].y) / 2;
                    const ellipseRadiusX = p.width * 0.33; // 33% of width
                    const ellipseRadiusY = p.height * 0.15; // 15% of height
                    const normalizedDistX = (lineX - centerX) / ellipseRadiusX;
                    const normalizedDistY = (lineY - centerY) / ellipseRadiusY;
                    const ellipticalDist = Math.sqrt(normalizedDistX * normalizedDistX + normalizedDistY * normalizedDistY);
                    const lineCenterAlpha = ellipticalDist < 1.0
                        ? p.map(ellipticalDist, 0, 1.0, 0.0, 1.0) * p.map(ellipticalDist, 0, 1.0, 0.0, 1.0)
                        : 1.0;

                    const alpha = p.map(distance, 0, 125, 0.5, 0) * lineCenterAlpha;
                    const minParticleSize = Math.min(particles[i].size, particles[j].size);
                    const strokeWeight = p.map(distance, 0, 125, minParticleSize, 0.5);
                    p.stroke(255, 51, 255, alpha * 255);
                    p.strokeWeight(strokeWeight);
                    p.line(particles[i].x, particles[i].y, particles[j].x, particles[j].y);
                }
            }
        }

        // Update and draw particles
        particles.forEach((particle) => {
            particle.update();
            particle.draw();
        });
    };

    p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight);
    };
};

new p5(sketch);
